import { render, staticRenderFns } from "./MultiwarehouseSection.vue?vue&type=template&id=29018454&"
import script from "./MultiwarehouseSection.vue?vue&type=script&lang=js&"
export * from "./MultiwarehouseSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports